import { QueryResources } from '@/lib/datx-jsonapi-react';
import { Transcript } from '@/resources/Transcript';

export const queryTranscriptsByLectureId = (lectureId: string): QueryResources<Transcript> => () =>
  lectureId
    ? [
        Transcript,
        {
          filter: {
            lecture_id: lectureId,
            scope: 'with_subtitles',
          },
          include: ['language'],
        },
      ]
    : null;
